export const THREAD_TAB_LABELS = {
	"sla-breached": "SLA breached",
	new: "Unassigned",
	my: "My inbox",
	open: "All",
	snoozed: "Snoozed",
	done: "Done",
	"close-loop": "Close loop",
} as const

export type ThreadTabValue = keyof typeof THREAD_TAB_LABELS
